document.addEventListener('DOMContentLoaded', function() {
  const headerMenu = document.querySelector(".header__inline-menu");
  
  if (!headerMenu) return;
  
  const menuItems = headerMenu.querySelectorAll("details");
  
  menuItems.forEach((menuItem) => {
    let closeTimeout;
    
    menuItem.addEventListener("mouseenter", () => {
      clearTimeout(closeTimeout);
      menuItem.setAttribute("open", true);
    });
    
    menuItem.addEventListener("mouseleave", () => {
      closeTimeout = setTimeout(() => {
        menuItem.removeAttribute("open");
      }, 200); // 200ms delay
    });
  });
});